import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";
import InlineLinkIconButton from "./inline-link-icon-button.jsx";

import * as util from "../../util";

class RecurringPassAnalyticsTable extends React.Component {
  constructor(props) {
    super(props);
    this._makeRow = this._makeRow.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _makeRow(data) {
    let noWrapTdStyle = { whiteSpace: "nowrap" };
    const autoRenew = data.should_autorenew ? "Y" : "N";
    const renewalDate = moment(data.renewal_date).format("MM/DD/YYYY");
    const expiredDate = moment(data.expired_date).format("MM/DD/YYYY");
    return (
      <Tr key={data._id}>
        <Td column="Name" value={data.person.name} style={{ width: 150 }}>
          <div>
            {data.pass.name}
            <InlineLinkIconButton
              onTouchTap={() => {
                window.open(
                  `/event_buckets/${this.props.eventBucket.id}/people/${data.person._id}?highlight_pass=${data.pass._id}`,
                  "_blank"
                );
              }}
              tooltip="View pass"
            />
          </div>
        </Td>
        <Td column="Email" value={data.person.email} style={noWrapTdStyle}>
          {data.person.email}
        </Td>
        <Td
          column="Phone Number"
          value={data.person.phone_number}
          style={noWrapTdStyle}
        >
          {data.person.phone_number}
        </Td>
        <Td column="Mailing Address" value={data.person.mailing_address}>
          {data.person.mailing_address}
        </Td>
        <Td
          column="Pass Bucket"
          value={(data.pass_bucket || { name: "Deleted Pass Bucket" }).name}
        >
          {(data.pass_bucket || { name: "Deleted Pass Bucket" }).name}
        </Td>
        {this.props.includeCardOnFile ? (
          <Td column="Card On File" value={data.person.payment_method_summary}>
            {data.person.payment_method_summary}
          </Td>
        ) : null}
        {this.props.includeRenewalDate ? (
          <Td column="Renewal Date" value={renewalDate}>
            {renewalDate}
          </Td>
        ) : null}
        {this.props.includeAutorenew ? (
          <Td
            column="Autorenew"
            value={autoRenew}
            style={
              autoRenew === "Y"
                ? {
                    backgroundColor: "rgb(76, 175, 80)",
                    color: "white",
                    borderBottom: "1px solid white"
                  }
                : {
                    backgroundColor: "rgb(244, 67, 54)",
                    color: "white",
                    borderBottom: "1px solid white"
                  }
            }
          >
            {autoRenew}
          </Td>
        ) : null}
        {this.props.includeExpiredDate ? (
          <Td column="Expired Date" value={expiredDate}>
            {expiredDate}
          </Td>
        ) : null}
      </Tr>
    );
  }

  downloadCsv(data, reportName) {
    util.clientSideDownload(
      `recurring_pass_analytics-${util.snakeCase(reportName)}-${util.snakeCase(
        this.props.eventBucket.name
      )}.csv`,
      "text/csv",
      util.makeCsv(
        [
          [
            "Name",
            "Email",
            "Phone Number",
            "Mailing Address",
            "Pass Bucket",
            "Card On File",
            "Renewal Date",
            "Autorenew"
          ]
        ].concat(
          data.map(d => {
            return [
              d.person.name,
              d.person.email,
              d.person.phone_number,
              d.person.mailing_address,
              (d.pass_bucket || { name: "Deleted Pass Bucket" }).name,
              d.person.payment_method_summary,
              d.renewal_date,
              d.should_autorenew ? "Y" : "N"
            ];
          })
        )
      )
    );
  }

  render() {
    const {
        data,
        includeCardOnFile,
        includeRenewalDate,
        includeAutorenew,
        includeExpiredDate
      } = this.props,
      rows = data.map(this._makeRow);

    let columns = [
      "Name",
      "Email",
      "Phone Number",
      "Mailing Address",
      "Pass Bucket"
    ];

    if (includeCardOnFile) {
      columns.push("Card On File");
    }
    if (includeRenewalDate) {
      columns.push("Renewal Date");
    }
    if (includeAutorenew) {
      columns.push("Autorenew");
    }
    if (includeExpiredDate) {
      columns.push("Expired Date");
    }

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={["Name", "Email", "Renewal Date", "Autorenew"]}
          defaultSort={
            includeExpiredDate
              ? { column: "Expired Date", direction: "desc" }
              : { column: "Renewal Date", direction: "asc" }
          }
          columns={columns}
        >
          {rows}
        </Table>
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No recurring pass data available.
          </div>
        ) : null}
        <RaisedButton
          style={{ marginTop: "1em" }}
          label="Download (.csv)"
          onTouchTap={() => this.downloadCsv(data, this.props.reportName)}
        />
      </div>
    );
  }
}

export default RecurringPassAnalyticsTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/recurring-pass-analytics-table.jsx